import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";
import complited from "../assets/complited.png";
import file from "../assets/file.png";
import video from "../assets/video.png";
import text from "../assets/text.png";

const Formation = () => {
  const { id } = useParams();
  const [nember, setnember] = useState(
    JSON.parse(localStorage.getItem("nember_info")) &&
      JSON.parse(localStorage.getItem("nember_info")).formation === id
      ? JSON.parse(localStorage.getItem("nember_info")).nember
      : -1
  );
  const { contextData } = useContext(AuthContext);
  const [unite, setunite] = useState([]);
  const [formation, setformation] = useState("");
  const [filerousource, setfilerousource] = useState([]);
  const [videorousource, setvideorousource] = useState([]);
  const [textrousource, settextrousource] = useState([]);
  const [progrestion, setprogrestion] = useState([]);

  const [videoroussourceprogress, setvideoroussourceprogress] = useState([]);
  const [fileroussourceprogress, setfileroussourceprogress] = useState([]);
  const [textroussourceprogress, settextroussourceprogress] = useState([]);

  const [refresh, setrefresh] = useState(true); // new state variable

  const [loaded, setLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message
  const navigate = useNavigate();

  const getendpo = async () => {
    const { data } = await axios.get(
      "https://pfebackend-zbz0.onrender.com/api/"
    );
  };

  const userisinformation = async () => {
    let responce;
    if (contextData.user) {
      try {
        responce = await axios.get(
          `https://pfebackend-zbz0.onrender.com/api/user/formation/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${contextData.authTokens.access}`,
            },
          }
        );
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setErrorMessage(
            "Sorry, there was a problem with the server. Please try again later."
          );
        }
        return;
      }
      if (!responce.data) {
        navigate("/notallowed");
      }
    } else {
      navigate("/notallowed");
    }
  };

  useEffect(() => {
    userisinformation();
    getunites();
    getformation();
    getProgrestion();
    getvideoroussourceprogress();
    getfileroussourceprogress();
    gettextroussourceprogress();
  }, []);

  useEffect(() => {
    if (unite.length !== 0) {
      markaunitedone();
    }
  }, [unite]);

  useEffect(() => {
    if (nember !== -1) {
      getFileRousourses();
      getVideoRousourses();
      getTextRousourses();
    }
  }, [nember]);

  useEffect(() => {
    getvideoroussourceprogress();
    getfileroussourceprogress();
    gettextroussourceprogress();
  }, [refresh]);

  const getProgrestion = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/unite/formation/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setprogrestion(responce.data);
  };

  const getvideoroussourceprogress = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/videoroussourceprogress/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setvideoroussourceprogress(responce.data);
  };

  const getfileroussourceprogress = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/fileroussourceprogress/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setfileroussourceprogress(responce.data);
  };

  const gettextroussourceprogress = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/user/textroussourceprogress/`,
        {
          headers: {
            Authorization: `Bearer ${contextData.authTokens.access}`,
          },
        }
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    settextroussourceprogress(responce.data);
  };

  const getunites = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/unites/${id}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setunite(responce.data);
    if (responce.data.length !== 0 && nember === -1) {
      localStorage.setItem(
        "nember_info",
        JSON.stringify({ nember: responce.data[0].id, formation: id })
      );
      setnember(responce.data[0].id);
    }
  };

  const getformation = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/formation/${id}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setformation(responce.data);
  };

  const getFileRousourses = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/filerousources/${id}/${nember}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }

    setfilerousource(responce.data);
    setrefresh(!refresh);
  };

  const getVideoRousourses = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/videorousources/${id}/${nember}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    setvideorousource(responce.data);
    setrefresh(!refresh);
  };

  const getTextRousourses = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/textrousources/${id}/${nember}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    settextrousource(responce.data);
    setrefresh(!refresh);
  };

  const changeunite = (e) => {
    setnember(e.id);
    localStorage.setItem(
      "nember_info",
      JSON.stringify({ nember: e.id, formation: id })
    );
  };

  const markafiledone = async (e) => {
    const { data } = await axios.post(
      `https://pfebackend-zbz0.onrender.com/api/user/file/${e.id}/`,
      null,

      {
        headers: {
          Authorization: `Bearer ${contextData.authTokens.access}`,
        },
      }
    );
    setrefresh(!refresh);
  };

  const markaunitedone = async () => {
    const { data } = await axios.get(
      `https://pfebackend-zbz0.onrender.com/api/user/unite/${id}/`,

      {
        headers: {
          Authorization: `Bearer ${contextData.authTokens.access}`,
        },
      }
    );
    setrefresh(!refresh);
  };

  const getfile = async (e) => {
    axios({
      url: `https://pfebackend-zbz0.onrender.com/api/file/${e.id}/`,
      method: "GET",
    }).then((response) => {
      const link = document.createElement("a");
      link.href = response.data.file;
      link.setAttribute("download", e.file.split("/").pop()); // set the filename and extension
      document.body.appendChild(link);
      link.click();
    });
    markafiledone(e);
  };
  function sortByOrder(...arrays) {
    const combinedPeople = arrays.flat();
    return combinedPeople.sort((a, b) => a.order - b.order);
  }

  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  }, []);

  return (
    <div>
      {errorMessage && <div className=" erroremailexiste">{errorMessage}</div>}

      <div className="formation_container">
        <div>
          <h3 className="formation--title">{formation.name}</h3>

          {unite.map((e, index) => {
            return (
              <div
                onClick={() => changeunite(e)}
                className="complited-container complited-container-unite formation-unites-display"
                key={e.id}
              >
                {progrestion.length !== 0 &&
                  progrestion[index].completed === true && (
                    <img className="complited-image" src={complited} alt="" />
                  )}

                <p className={`unite`} id={`unite-${index}`}>
                  {e.name}
                </p>
              </div>
            );
          })}
          <Link
            className="custom-link formation-link"
            to={`/formation/${id}/rooms`}
          >
            {" "}
            Forums
          </Link>

          {/*  */}
          {/*  */}
          {/*  */}
          {/*  */}
          {contextData.user && contextData.user.role === "admin" && (
            <Link
              className="custom-link formation-link "
              to={`/formation/modifier/${id}`}
            >
              modifier formation
            </Link>
          )}
          {contextData.user && contextData.user.role === "teacher" && (
            <Link
              className="custom-link formation-link"
              to={`/formation/modifier/${id}`}
            >
              modifier formation
            </Link>
          )}
        </div>
        <div className="resources">
          {unite.length !== 0 &&
            unite.map((e, i) => {
              if (e.id === nember) {
                return (
                  <h1 className="chaptertitle" key={i}>
                    {e.name}
                  </h1>
                );
              }
            })}

          {sortByOrder(filerousource, videorousource, textrousource).map(
            (e, index) => {
              return (
                <div key={index}>
                  {e.type === "file" ? (
                    <div
                      className="complited-container reselement formation-ressource-display"
                      key={e.id}
                      onClick={() => getfile(e)}
                    >
                      {fileroussourceprogress.length !== 0 &&
                      fileroussourceprogress.filter(
                        (item) => item.fileroussource === e.id
                      )[0].completed ? (
                        <img
                          className="complited-image"
                          src={complited}
                          alt=""
                        />
                      ) : (
                        <img className="complited-image" src={file} alt="" />
                      )}

                      <p className="file">{e.name}</p>
                    </div>
                  ) : e.type === "video" ? (
                    <Link
                      to={`/formation/${id}/video/${e.id}`}
                      className="complited-container reselement formation-ressource-display"
                      key={e.id}
                    >
                      {videoroussourceprogress.length !== 0 &&
                      videoroussourceprogress.filter(
                        (item) => item.videoroussource === e.id
                      )[0].completed ? (
                        <img
                          className="complited-image"
                          src={complited}
                          alt=""
                        />
                      ) : (
                        <img className="complited-image" src={video} alt="" />
                      )}

                      <div>
                        <p className="custom-link" key={e.id}>
                          {e.name}
                        </p>
                      </div>
                    </Link>
                  ) : (
                    <Link
                      to={`/formation/${id}/text/${e.id}`}
                      className="complited-container reselement formation-ressource-display"
                    >
                      {textroussourceprogress.length !== 0 &&
                      textroussourceprogress.filter(
                        (item) => item.textroussource === e.id
                      )[0].completed ? (
                        <img
                          className="complited-image"
                          src={complited}
                          alt=""
                        />
                      ) : (
                        <img className="complited-image" src={text} alt="" />
                      )}

                      <p className="custom-link" key={e.id}>
                        {e.name}
                      </p>
                    </Link>
                  )}
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default Formation;
